<template>
  <div class="rj-page-card">
    <div class="rj-page-card__content">
      <div class="rj-row">
        <el-form ref="form" :model="formData" :rules="rules">
          <div class="accept-order-content">
            <div class="accept-order-fields">
              <el-form-item prop="byType" label="是否接单">
                <el-radio-group v-model="formData.byType">
                  <el-radio :label="1">
                    确认接单
                  </el-radio>
                  <el-radio :label="9">
                    拒绝接单
                  </el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item v-if="formData.byType==9" prop="Reason">
                <el-input v-model.trim="formData.Reason" type="textarea" :rows="4" placeholder="请输拒绝理由" show-word-limit maxlength="200" />
              </el-form-item>
            </div>
            <div class="ab-order-warning">
              <p>根据《2026年度合作伙伴合作协议》及其附件《锐捷网络合作伙伴市场秩序管理规定》，严禁从事AB单行为，否则将按合作协议及其附件的约定承担违约责任。</p>
              <p>AB单是指：贵公司在下单系统中接单时确认供货给A公司，实际供货给B公司的行为；或者在下单系统中接单时确认供货的产品型号和数量，与实际总经销商与下级渠道供货合同中产品型号和数量不一致的行为。</p>
              <p>请贵公司在点击“确认接单”前，务必自行核实贵公司与下级渠道已签署或将要签署的供货合同：（1）合同签约主体是否与系统派单信息中的首级集成商名称一致；（2）产品型号和数量是否与系统派单信息一致。</p>
              <p>如不一致，请点击“拒绝接单”。</p>
              <p>如贵公司点击“确认接单”，即视为贵公司已阅读、理解并接受《2026年度合作伙伴合作协议》及其附件《锐捷网络合作伙伴市场秩序管理规定》的相关约定，且确认系统派单信息与贵公司已签署或将要签署的供货合同的签约主体以及产品型号、数量一致。如实际信息不一致，贵公司仍点击“确认接单”，即构成AB单行为，贵公司应承担相应违约责任。</p>
            </div>
          </div>
          <el-form-item style="margin-bottom: 4px">
            <el-button type="primary" :loading="loading" @click="submit">
              确认
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { mapActions } from 'vuex';
import { distributorConfirmOrRefusOrder } from '../../../../API/index';
import eventBus from '@/libs/eventBus';
export default {
  data () {
    return {
      formData: {
        byType: 1,
        Reason: ''
      },
      loading: false,
      rules: {
        Reason: [{ required: true, message: '请输拒绝理由', trigger: 'blur' }],
        byType: [{ required: true, message: '请选择是否接单', trigger: 'change' }]
      }
    };
  },
  props: {
    // 数据由父组件传递
    baseInfo: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions([
      'getIsCurrentApprover'
    ]),
    submit () {
      this.$refs.form.validate(async (val) => {
        // 输入验证成功后 调用接口
        if (val) {
          // let isApprover = await this.getIsCurrentApprover(this.baseInfo.documentID);
          // if (!isApprover) {
          let params = {
            documentID: this.baseInfo.documentID,
            orderType: this.baseInfo.orderType,
            optionType: '3',
            newEcpFlag: Number(this.$route.query.newEcpFlag)
          };
          if (this.formData.byType === 9) {
            params.optionType = 4;
            params.reason = this.formData.Reason;
          } else if (this.formData.byType === 1) {
            params.optionType = 3;
            params.reason = '同意';
          }
          this.loading = true;
          distributorConfirmOrRefusOrder(params).then((res) => {
            this.loading = false;
            let json = res.data;
            if (json.status === '200') {
              eventBus.$emit('CompleteDistrOrder'); // 完成订单操作
              this.$router.replace({
                name: 'DistributorOrderList'
              });
            }
          }).catch(() => {
            this.loading = false;
          });
        }
        // }
      });
    }
  },
  mounted () {

  }
};
</script>
<style lang="scss" scoped>
.accept-order-content {
  display: flex;
  align-items: flex-start;

  @media (max-width: 1500px) {
    flex-direction: column;
  }
}

.accept-order-fields {
  flex: 0 0 348px;

  @media (max-width: 1500px) {
    flex: none;
    width: 100%;
  }
}

.ab-order-warning {
  flex: 1;
  min-width: 0;
  margin-left: 16px;
  color: #f56c6c;
  font-weight: bold;
  line-height: 1.8;

  @media (max-width: 1500px) {
    margin-top: 12px;
    margin-left: 0;
  }

  p {
    margin: 0 0 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
